import { createFileRoute, Outlet } from "@tanstack/react-router";
export const Route = createFileRoute("/contents/patient-info")({
  component: LayoutComponent,
  head() {
    return {
      meta: [
        {
          title: "Patient Info | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Patient resources for TMS, SAINT TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs, FL. Financing, insurance, and what to expect during treatment.",
        },
        {
          property: "og:title",
          content: "Patient Info | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Patient resources for TMS, SAINT TMS, and SPRAVATO at Neuro Wellness TMS in Coral Springs, FL. Financing, insurance, and what to expect during treatment.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/contents/patient-info",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [],
    };
  },
});
function LayoutComponent() {
  return <Outlet />;
}
